import React from 'react'
import AnimatedMockup from '@components/AnimatedMockup'

interface FullPageSectionProps {
  title: React.ReactNode
  description?: React.ReactNode
  image?: any
  isTitleCentered?: boolean
  isSingleCol?: boolean
  goToLink?: string | React.ReactNode
  children?: React.ReactNode
  isDecoupled?: boolean
  aboutus?: boolean
}

const FullPageSection: React.FC<FullPageSectionProps> = ({
  title,
  description,
  image,
  children,
  isTitleCentered,
  isSingleCol,
  goToLink,
  isDecoupled = false,
  aboutus = false
}) => {
  if (aboutus) {
    image = (
      <>
        <AnimatedMockup />
      </>
    )
  }

  return (
    <div className={`container mx-auto px-6 pt-8 relative h-full sm:pt-32 md:pt-0 lg:px-8`}>
      {!isTitleCentered && (
        <div className="w-full flex flex-col h-full">
          <div className="row flex flex-wrap grow pt-16 justify-between">
            <div className={`texts mb-4 mt-8 flex flex-col pr-4 md:mt-0 md:w-[45%] md:justify-center xs:mb-0 xs:pr-4 sm:pr-0`}>
              <>{title}</>
              <div className="descriptionContainer pt-4 font-medium text-xs leading-relaxed xs:text-sm sm:text-base md:pl-6 md:pt-4 md:text-lg">{description}</div>
            </div>

            <div className="image w-10/12 xs:w-full px-4 flex justify-center items-center sm:w-3/4 sm:mx-auto md:mx-0 md:w-1/2 md:items-center md:justify-end h-[35%] sm:h-[65%] md:h-full">
              <div className="relative w-full">{image}</div>
            </div>
          </div>
          <div className="servicesContainer flex flex-col px-4 mb-6 w-full lg:px-8">{children}</div>
        </div>
      )}
      {isTitleCentered && (
        <div
          className="row h-full flex-col pt-24 sm:pt-0 sm:justify-center relative flex flex-wrap grow"
        >
          <div className={`titleCentered w-full mb-4 flex flex-col sm:pr-4 xs:mb-0 xs:pr-4 sm:pr-0 ${!isDecoupled ? '-mt-12' : ''}`}>
            <div className="sm:text-center">{title}</div>
            <div className="w-full">{children}</div>
          </div>
          {goToLink && (
            <div className="servicesContainer absolute bottom-0 flex flex-col px-4 mb-6 w-full lg:px-8">
              {goToLink}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default FullPageSection
